// External Imports
import { createSelector } from 'reselect';

import { createSelectContentItemBySlug } from './createSelectContentItem.mjs';
// Internal Imports
import { selectContentType } from './selectMatch.mjs';

// Local Functions
const selectActiveContentItemBySlug = createSelector([selectContentType], (contentType) =>
  createSelectContentItemBySlug(contentType),
);

const selectActiveContentItem = createSelector(
  [
    selectActiveContentItemBySlug,
    // This sucks for memoization, but getItem for now is made in a way that doesn't get better than that
    (state) => state,
  ],
  (getItem, state) => getItem(state),
);

// Module Exports
export { selectActiveContentItem };
